module.exports = __webpack_public_path__ + "img/baoente.0245a1fd.jpg";